import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch, computed, onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';

import Toast from 'primevue/toast';

import AuthorizedLayout from './layouts/AuthorizedLayout.vue';
import GuestLayout from './layouts/GuestLayout.vue';

import { authService } from './utils/api/authService';

const APP_TITLE_SUFFIX = 'Kalkulator Energetyczny projekt';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

watch(route, (newRoute) => {
  const pageTitle = newRoute.meta.title as string | undefined;
  document.title = pageTitle ? `${pageTitle} | ${APP_TITLE_SUFFIX}` : APP_TITLE_SUFFIX;
});

const layout = computed(() => {
  return route.meta.layout === 'AuthorizedLayout' ? AuthorizedLayout : GuestLayout;
});

onBeforeMount(async () => {
  await authService.getCsrf();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
      default: _withCtx(() => [
        _createVNode(_component_RouterView)
      ]),
      _: 1
    })),
    _createVNode(_unref(Toast), {
      class: "text-black",
      position: "bottom-right"
    })
  ], 64))
}
}

})